import React from "react";
import styles from "./OtpVerification.module.scss";
import { useNavigate } from "react-router-dom";
import toast from "components/shared/toast/toast";
import { emailRegex } from "utils/regex";
import { FORGOT_PASSWORD } from "services/apiEndpoints";
import publicRequest from "services/publicRequest";
import LoginLayout from "components/layouts/loginlayout/LoginLayout";
import * as Yup from "yup";
import { requiredMessage } from "utils/utils";
import { Form, Formik } from "formik";
import Button from "components/shared/button/Button";
import { PATH } from "utils/constants";
import { InputLabel, TextField } from "@mui/material";

const ForgotPassword = () => {
  const navigate = useNavigate();

  const initialValues = {
    email: "",
  };

  const validationSchema = Yup.object({
    email: Yup.string()
      .required(requiredMessage("Email ID"))
      .matches(emailRegex, "Invalid email format!"),
  });

  const forgotPassword = (values) => {
    return publicRequest.post(FORGOT_PASSWORD, values);
  };

  const handleSubmit = async (values) => {
    const p = forgotPassword(values);
    await toast.promise(p, {
      loading: "Email sending...",
      success: () => "Email sent successfully",
      error: () => "Email not found",
    });
    // navigate(PATH.publicRoutes.LOGIN.path, { state: { email: values.email } })
    navigate(PATH.publicRoutes.LOGIN.path);
  };

  return (
    <LoginLayout>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formik) => {
          return (
            <div className={styles.mainDiv}>
              <p className={styles.heading}>Forgot Password</p>
              <p className={styles.subHeading}>Please Enter Email ID</p>
              <Form className={styles.form} autoComplete="off">
                {/* <FormikControl
                  name="email"
                  control="input"
                  label="Email ID"
                  placeholder="Enter Email ID"
                  isRequired={true}
                /> */}
                <InputLabel sx={{ fontSize: "14px", fontWeight: 600 }}>
                  Email ID<span style={{ color: "red" }}>*</span>
                </InputLabel>
                <TextField
                  onChange={formik.handleChange}
                  value={formik.values.email}
                  onBlur={formik.handleBlur}
                  name="email"
                  size="small"
                  type="email"
                  margin="normal"
                  className={styles.marginTop2px}
                  sx={{
                    "& .MuiFormHelperText-root": {
                      margin: 0,
                    },
                  }}
                  placeholder="Enter Email ID"
                  error={Boolean(formik.errors.email && formik.touched.email)}
                  helperText={
                    formik.errors.email &&
                    formik.touched.email &&
                    String(formik.errors.email)
                  }
                  fullWidth
                />
                <Button
                  type="submit"
                  className={styles.button}
                  disabled={formik.isSubmitting}
                >
                  Submit
                </Button>
                <p className={styles.bottomText}> <span 
                    className="link-text" 
                    onClick={() => navigate(PATH.publicRoutes.LOGIN.path)}
                  >
                    Back to Login
                  </span>
                </p>
              </Form>
            </div>
          );
        }}
      </Formik>
    </LoginLayout>
  );
};

export default ForgotPassword;
